let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("19CSn")).then(() => parcelRequire('d9LED'));